export const environment = {

  production: false,

  firebaseConfig: {

    apiKey: "AIzaSyDrEBQpO08taDgM6yp3XNqoIIR8zjJb4jg",

    authDomain: "pfts-f2110.firebaseapp.com",

    projectId: "pfts-f2110",

    storageBucket: "pfts-f2110.firebasestorage.app",

    messagingSenderId: "695798473675",

    appId: "1:695798473675:web:02bc836a6c782d209a8c4e",

    measurementId: "G-X2613V7FP0"
  }
};